import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import { Photo } from '../models/Profile';
import { GetSingleUserById } from '../models/user';

import { store } from './store';

export default class ProfileStore {
  profile: GetSingleUserById | null = null;
  loadingProfile = false;
  uploading = false;
  loading = false;
  constructor() {
    makeAutoObservable(this);
  }

  loadProfile = async (id: string) => {
    this.loadingProfile = true;
    try {
      const profile = await agent.Profiles.get(id);
      runInAction(() => {
        this.profile = profile;
        this.loadingProfile = false;
      });
    } catch (error) {
      console.log(error);
      runInAction(() => (this.loadingProfile = false));
    }
  };

  uploadPhoto = async (file: Blob) => {
    this.uploading = true;
    try {
      let response, alteredResponse: Photo;
      if (store.commonStore.devEnv) {
        response = await agent.Files.localFileUpload(
          file,
          'Profile',
          store.userStore.user?.id,
        );
        const url = response?.data.path.replace(/\\\\/g, '\\');
        alteredResponse = {
          id: response.data.id,
          url: url,
          isMain: false,
        };
        await agent.Profiles.addPhotoLocal(alteredResponse);
      } else {
        response = await agent.Profiles.uploadPhoto(file);
        alteredResponse = response.data;
      }
      runInAction(() => {
        if (this.profile) {
          this.profile.photos?.push(alteredResponse);
          if (alteredResponse.isMain && store.userStore.user) {
            store.userStore.setImage(alteredResponse.url);
            this.profile.image = alteredResponse.url;
          }
        }
        this.uploading = false;
      });
    } catch (error) {
      console.log(error);
      runInAction(() => (this.uploading = false));
    }
  };
  setMainPhoto = async (photo: Photo) => {
    this.loading = true;
    try {
      if (store.commonStore.devEnv) {
        await agent.Profiles.setMainPhotoLocal(encodeURI(photo.url));
      } else {
        await agent.Profiles.setMainPhoto(photo.id);
      }
      store.userStore.setImage(photo.url);
      runInAction(() => {
        if (this.profile && this.profile.photos) {
          if (this.profile.photos.find((p) => p.isMain)) {
            this.profile.photos.forEach((element) => {
              element.isMain = false;
            });
          }
          // this.profile.photos.find(p => p.id === photo.id)!.isMain = true;
          if (this.profile.photos.find((p) => p.id === photo.id)) {
            this.profile.photos.forEach((p) =>
              p.id === photo.id ? (p.isMain = true) : false,
            );
          }
          this.profile.image = photo.url;
          this.loading = false;
        }
      });
    } catch (error) {
      runInAction(() => (this.loading = false));
      console.log(error);
    }
  };
  deletePhoto = async (photo: Photo) => {
    this.loading = true;
    try {
      if (store.commonStore.devEnv) {
        await agent.Profiles.deletePhotoLocal(encodeURI(photo.url));
      } else {
        await agent.Profiles.deletePhoto(photo.id);
      }
      runInAction(() => {
        if (this.profile) {
          this.profile.photos = this.profile.photos?.filter(
            (p) => p.id !== photo.id,
          );
          this.loading = false;
        }
      });
    } catch (error) {
      runInAction(() => (this.loading = false));
      console.log(error);
    }
  };
}
